// extracted by mini-css-extract-plugin
export default {"Container":"TableHeader_Container__g8JH9"};